<ng-container *upuTranslate="let t">
  <figure class="max-w-[27%] select-none mb-8">
    <img
      src="assets/403.png"
      alt="403 Access Restricted"
      class="block size-full"
      loading="eager"
      draggable="false"
    />
  </figure>

  <section
    class="w-[620px] flex flex-col items-center justify-center text-center relative"
  >
    <h1 class="text-primary font-medium text-4xl mb-3">
      {{ t('errorPages.accessRestricted.title') }}
    </h1>

    <p class="text-[#79747E] text-lg mb-8">
      {{ t('errorPages.accessRestricted.message') }}
    </p>

    <footer class="flex gap-3 flex-wrap">
      <button
        id="go-back-button"
        mat-stroked-button
        type="button"
        class="border-primary text-primary"
        (click)="goBack()"
      >
        <mat-icon class="text-xl">arrow_back</mat-icon>
        {{ t('errorPages.goBack') }}
      </button>

      <a id="main-page-button" routerLink="/" mat-flat-button color="primary">
        {{ t('errorPages.mainPage') }}
      </a>
    </footer>
  </section>
</ng-container>
